var exports = {
  "Nr": "x61f99309--4eed0d--card",
  "iq": "x61f99309--4eed0d--image-container",
  "pq": "x61f99309--4eed0d--info",
  "DD": "x61f99309--4eed0d--title",
  "op": "x61f99309--4eed0d--title_clamped",
};

module.exports = exports;
